__turbopack_context__.v({
  "headline": "trustPilotReviews-module-scss-module__ekIooq__headline",
  "subHeadline": "trustPilotReviews-module-scss-module__ekIooq__subHeadline",
});
